import { Box, Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allTemasAcademicosAction,
  deleteTemasAcademicosAction,
  setActivoTemasAcademicosAction,
} from '../TemasAcademicosAction';
import { PARAMS_TEMAS_ACADEMICOS } from '../TemasAcademicosReducer';

export const Links = styled.a`
  cursor: pointer;
  color: black;
  margin: 0px 0px;
  text-decoration: none;

  &:hover {
    color: blue;
  }
`;

const ListadoTemasAcademicos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const templateStore = Redux.useSelector((state) => state.template);
  const loginStore = Redux.useSelector((state) => state.login);
  const temasAcademicosStore = Redux.useSelector(
    (state) => state.temasAcademicos,
  );

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {};
      dispatch({ type: PARAMS_TEMAS_ACADEMICOS, payload });
      if (temasAcademicosStore.all && temasAcademicosStore.all.length === 0) {
        await allTemasAcademicosAction(dispatch, {
          ...temasAcademicosStore.params,
          ...payload,
        });
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    let dataRows = [];
    temasAcademicosStore.all.forEach((el) => {
      dataRows.push({
        ...el,
        titulo: {
          titulo: el.titulo,
          link: el.link,
          referencia: el.referencia,
        },
      });
    });
    setRows(dataRows);
  }, [temasAcademicosStore.all]);

  const _handleEditClick = async (id) => {
    const data = temasAcademicosStore.all.find((el) => el.id === id);
    await setActivoTemasAcademicosAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteTemasAcademicosAction(
      { dispatch, notify },
      temasAcademicosStore.activo.id,
      temasAcademicosStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.titulo.name,
      label: CONST.titulo.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack>
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value.titulo}
              </NameComponent>
              <Box
                sx={{
                  mr: 1,
                  width: '30vw',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
              >
                <strong>Link: </strong>
                <Links target="_blank" href={value}>
                  {value.link}
                </Links>
              </Box>
              <Box
                sx={{
                  mr: 1,
                  width: templateStore.settings.open ? '45vw' : '55vw',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
              >
                <strong>Referencia: </strong>
                <Links target="_blank" href={value} sx={{}}>
                  {value.referencia}
                </Links>
              </Box>
            </Stack>
          );
        },
      },
    },

    {
      name: CONST.numero.name,
      label: CONST.numero.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'materias',
      label: 'Materias',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value.length > 0 ? (
            <Stack
              spacing={1}
              alignItems="flex-start"
              justifyContent="flex-start"
            >
              {value.map((el) => {
                return (
                  <Chip
                    label={el.materia.nombre}
                    sx={{ fontWeight: 'bold' }}
                    size="small"
                    mr={1}
                  />
                );
              })}
            </Stack>
          ) : (
            <Chip label="Sin asignar" color="error" size="small" />
          );
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value.nombre}
                size="small"
                color={value.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row" sx={{ width: '60px' }}>
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  const data = temasAcademicosStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoTemasAcademicosAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    reponsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      // const data = temasAcademicosStore.all.find((el) => el.id === rowData[0]);
      return <Grid container></Grid>;
    },
    customSearch: (q, currentRow, columns) => {
      q = q.toLowerCase();
      const data = temasAcademicosStore.all.find(
        ({ id }) => id === currentRow[0],
      );
      if (!data) return true;
      const temaData = `${data.titulo} 
        `.toLowerCase();
      return temaData.includes(q);
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={temasAcademicosStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={`Listado de (${temasAcademicosStore.all.length}) registros`}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {temasAcademicosStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {temasAcademicosStore.activo.titulo}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoTemasAcademicos;
